import { render } from "./TheHeader.vue?vue&type=template&id=a9d18718&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=a9d18718&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9d18718"

export default script